import Stack from 'src/app/atoms/Layout/Stack/Stack';
import styled from 'styled-components';

export const TabSelectorContainer = styled(Stack)`
  .tab-button {
    min-height: 44px;
  }
`;
